import React from "react";

const BooleanRadio = ({ name, txt, state, value, onClick }) => (
  <label className="pageFormSubRadioCase colorBlack fontMeduim">
    <input
      onChange={(e) => onClick(value, name)}
      type="checkbox"
      name={name}
      checked={state === value ? true : false}
    />

    <span className="pageFormSubRadioCaseCheckmark"></span>
    <span className="pageFormSubRadioCasetext fontMedium">{txt}</span>
  </label>
);

export default BooleanRadio;



// WEBPACK FOOTER //
// ./src/containers/components/BooleanRadio.js